<template>
  <div class="results">
    <v-row no-gutters class="justify-center">
      <v-col
      cols="12"
      sm="11"
      md="8"
      >
    
        <v-card class="noprint">
            <v-card-text class="py-4 text-caption text-justify">El Lcdo. Ricardo Ortiz Morales no se hace responsable por los resultados en el uso de esta herramienta gratuita y cada usuario ha de utilizarla bajo su responsabilidad.</v-card-text>
        </v-card>

        <v-alert
          v-model="this.variables.alerta"
          dismissible
          color="orange"
          border="left"
          elevation="2"
          colored-border
          icon="mdi-alert"
          transition="scale-transition"
          class="mt-4"
        >
        Cuando el valor de la cancelación exceda los cinco millones de dólares ($5,000,000), los honorarios notariales se establecerán por
        acuerdo entre las partes y el notario. En ningún caso de los incluidos en este inciso la cuantía a pagar por honorarios
        notariales será menor de doscientos cincuenta dólares ($250). La calculadora asignará $250 en honorarios. Usted puede
        cambiar la cuantía de honorarios más adelante en esta pantalla.
        </v-alert>

        <v-alert
          v-model="this.variables.alerta2"
          dismissible
          color="orange"
          border="left"
          elevation="2"
          colored-border
          icon="mdi-alert"
          transition="scale-transition"
          class="mt-4"
        >
        Por la autorización de instrumentos cuyo valor de la transacción exceda de $5,000,000, los honorarios notariales serán del 0.50% al 1%
        de dicha suma, más los honorarios notariales que sean establecidos por acuerdo entre las partes y el (la) notario(a) por el exceso de
        $5,000,000. La calculadora asignará el valor de los primeros $5,000,000 según el porciento entrado. Usted puede añadir el exceso sobre
        esa cantidad más adelante en esta pantalla.
        </v-alert>

        <v-col
        cols="12"
        class="px-0 printstyle"
        >
          <v-row class="my-2">
            <v-col
            cols="6"
            sm="6"
            >
              <v-row no-gutters>
                <v-col cols="6"><h4 class="red--text">Negocio:</h4></v-col>
                <v-col cols="6"><h4>{{ variables.tiponegocio }}</h4></v-col>
              </v-row>
            </v-col>
            <v-col
            cols="6"
            sm="6"
            >
              <v-row no-gutters>
                <v-col cols="6"><h4 class="red--text">Cuantía:</h4></v-col>
                <v-col cols="6"><h4>{{ variables.valornegocio | toCurrency }}</h4></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card class="printstyle">
            <v-card-title class="red darken-3 text-h6 printstyle-heading">Sellos para las escrituras</v-card-title>
            <h3 class="pa-4 text-subtitle-1 red--text font-weight-bold printstyle">Escritura Original</h3>

            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            >
              <v-col cols="6" class="pa-0 printstyle">Rentas Internas</v-col> <v-col cols="3" class="grey--text pl-1 pa-0 printstyle">#5120</v-col> <v-col cols="3" class="pa-0 text-right printstyle">{{ variables.rentasinternasoriginal | toCurrency }}</v-col>
            </v-row>

            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            v-if="this.variables.tiponegocio == 'Compraventa' ||
                  this.variables.tiponegocio == 'Hipoteca' ||
                  this.variables.tiponegocio == 'Cancelación de pagaré'"
            >
              <v-col cols="6" class="pa-0 printstyle">Asistencia Legal</v-col> <v-col cols="3" class="grey--text pl-1 pa-0 printstyle">#5203</v-col> <v-col cols="3" class="pa-0 text-right printstyle">{{ variables.asistencialegaloriginal | toCurrency }}</v-col>
            </v-row>

            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            >
              <v-col cols="6" class="pa-0 printstyle">Impuesto Notarial</v-col> <v-col cols="3" class="grey--text pl-1 pa-0 printstyle">#5155</v-col> <v-col cols="3" class="pa-0 text-right printstyle">$1.00</v-col>
            </v-row>


            <h3 class="pa-4 text-subtitle-1 red--text font-weight-bold printstyle">Copia Certificada</h3>
            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            >
              <v-col cols="6" class="pa-0 printstyle">Rentas Internas</v-col> <v-col cols="3" class="grey--text pa-0 printstyle">#5120</v-col> <v-col cols="3" class="pa-0 text-right printstyle">{{ variables.rentasinternascopia | toCurrency }}</v-col>
            </v-row>

            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            v-if="this.variables.tiponegocio == 'Compraventa' ||
                  this.variables.tiponegocio == 'Hipoteca' ||
                  this.variables.tiponegocio == 'Cancelación de pagaré'"
            >
              <v-col cols="6" class="pa-0 printstyle">Asistencia Legal</v-col> <v-col cols="3" class="grey--text pa-0 printstyle">#5203</v-col> <v-col cols="3" class="pa-0 text-right printstyle">{{ variables.asistencialegalcopia | toCurrency }}</v-col>
            </v-row>

            <v-row
            cols="12"
            class="ma-4 text-body-2 printstyle-row"
            >
              <v-col cols="6" class="pa-0 printstyle">Impuesto Notarial</v-col> <v-col cols="3" class="grey--text pa-0 printstyle">#5155</v-col> <v-col cols="3" class="pa-0 text-right printstyle">$1.00</v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row
            class="px-4 my-0"
            >
              <v-col
              cols="7"
              class="pr-0 py-2"
              >
                <h2 class="text-h6 pr-0 red--text">Total Sellos</h2>
              </v-col>
              <v-col
              cols="5 pl-0 py-2 text-right"
              >
                <h2 class="text-h6 red--text">{{ variables.totalarancelesescritura | toCurrency }}</h2>
              </v-col>
            </v-row>
          </v-card>
         
        </v-col>
        <v-expand-transition>
          <v-col
          cols="12"
          class="px-0"
          v-if="variables.aranceles"
          >
            <v-card class="printstyle">
              <v-card-title class="red darken-3 text-h6 printstyle-heading"><v-col cols="11" class="pa-0 printstyle">Registro de la Propiedad</v-col><v-col cols="1" class="pa-0 text-right noprint"><v-icon color="white" @click="registrodelete">mdi-trash-can-outline</v-icon></v-col></v-card-title>
              <v-row
              cols="12"
              class="py-2 px-4 my-0 text-body-2"
              >
                <v-col cols="6" class="pr-0 printstyle">Comprobante presentación</v-col> <v-col cols="3" class="grey--text pl-1 pr-0 printstyle">#5121</v-col> <v-col cols="3" class="pl-0 text-right printstyle">{{ variables.comprobantepresentacion | toCurrency }}</v-col>
                <v-col cols="6" class="pr-0 printstyle">Presentación telemática</v-col> <v-col cols="3" class="grey--text pl-1 pr-0 printstyle">#5101</v-col> <v-col cols="3" class="pl-0 text-right printstyle">{{ variables.presentaciontelematica | toCurrency }}</v-col>
                <v-col cols="6" class="pr-0 printstyle">Comprobante de inscripción</v-col> <v-col cols="3" class="grey--text pl-1 pr-0 printstyle">#5111</v-col> <v-col cols="3" class="pl-0 text-right printstyle">{{ variables.comprobanteinscripcion | toCurrency }}</v-col>
                <v-col cols="6" class="pr-0 printstyle">Sello Rentas Internas</v-col> <v-col cols="3" class="grey--text pl-1 pr-0 printstyle">#5120</v-col> <v-col cols="3" class="pl-0 text-right printstyle">{{ variables.rentasinternaspresentacion | toCurrency }}</v-col>
              </v-row>

              <v-divider></v-divider>

              <v-row
              class="px-4 my-0"
              >
                <v-col
                cols="7"
                class="pr-0 py-2"
                >
                  <h2 class="text-h6 pr-0 red--text">Total Aranceles</h2>
                </v-col>
                <v-col
                cols="5 pl-0 py-2 text-right"
                >
                  <h2 class="text-h6 red--text">{{ variables.totalarancelesregistro | toCurrency }}</h2>
                </v-col>
              </v-row>
            </v-card>
            
          </v-col>
        </v-expand-transition>
        
        <v-col
        cols="12"
        class="px-0"
        >
          <v-card class="printstyle">
            <v-card-title class="red darken-3 text-h6 printstyle-heading">
              <v-col cols="11" class="pa-0 printstyle">Honorarios</v-col>
              <v-col cols="1" class="pa-0 text-right noprint">
                <v-dialog
                  v-model="dialogpartidas"
                  width="500"
                  @keydown.esc="cerrardialogpartidas"
                  @keydown.enter="anadirpartida"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="pa-0 white--text"
                    >mdi-plus-circle-outline</v-icon>
                  </template>

                  <v-card>
                    <v-card-title class="h5 grey darken-3">
                      <slot name="infotitle">Nueva partida honorarios</slot>
                    </v-card-title>

                    <v-card-text class="py-4">
                      <v-container>
                          <v-form ref="formpartidas">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                    color="primary"
                                    label="Concepto"
                                    hint="Ej. Orientación, Planilla Traslado, etc."
                                    persistent-hint
                                    clearable
                                    autofocus
                                    autocomplete="off"
                                    :rules="partidasRules"
                                    v-model="nuevapartidadescripcion"
                                    >
                                    </v-text-field>
                                    <v-currency-field
                                    color="primary"
                                    label="Honorarios"
                                    hint="Entre los honorarios de esta partida"
                                    clearable
                                    prefix="$"
                                    type="number"
                                    autocomplete="off"
                                    v-model="nuevapartidahonorariospartida"
                                    :rules="valorRules"
                                    />
                                </v-col>
                            </v-row>
                          </v-form>
                      </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="cerrardialogpartidas"
                      >
                        Cerrar
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="anadirpartida"
                      >
                        Añadir
                      </v-btn>

                    </v-card-actions>
                  </v-card>

                </v-dialog>

              </v-col>
            </v-card-title>
            <v-row
            cols="12"
            class="ma-4 text-body-2 justify-space-between printstyle-row"
            >
              <v-col cols="6" class="pa-0 printstyle">Honorarios notariales</v-col>
              <v-col cols="5" class="pa-0 pr-2 text-right printstyle printstyle-partidas-currency">{{ variables.honorariosnotariales | toCurrency }}</v-col>
              <v-col cols="1" class="pa-0 text-right noprint">

              <v-dialog
                v-model="dialoghonorariosnotariales"
                width="500"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="pa-0 grey--text"
                  >mdi-square-edit-outline</v-icon>
                </template>

                <v-card>
                  <v-card-title class="h5 grey darken-3">
                    <slot name="infotitle">Cambiar honorarios</slot>
                  </v-card-title>

                  <v-card-text class="py-4">
                    <v-container>
                        <v-form ref="form">
                          <v-row>
                              <v-col>
                                  <v-currency-field
                                  color="primary"
                                  label="Honorarios notariales"
                                  hint="Entre la nueva cantidad que quiere que se refleje"
                                  persistent-hint
                                  clearable
                                  autofocus
                                  prefix="$"
                                  type="number"
                                  autocomplete="off"
                                  v-model="variables.honorariosnotariales"
                                  :rules="valorRules"
                                  />
                              </v-col>
                          </v-row>
                        </v-form>
                    </v-container>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="grey"
                      text
                      @click="cerrardialogohonorariosnotariales"
                    >
                      Cerrar
                    </v-btn>

                  </v-card-actions>
                </v-card>

              </v-dialog>

              </v-col>
            </v-row>

            <v-row
            cols="12"
            class="ma-4 text-body-2 justify-space-between printstyle-row"
            v-if="variables.estudiodetitulo"
            >
              <v-col cols="6" class="pa-0 printstyle">Estudio de título</v-col><v-col cols="5" class="pa-0 pr-2 text-right printstyle printstyle-partidas-currency">{{ variables.precioestudiodetitulo | toCurrency }}</v-col> <v-col cols="1" class="pa-0 text-right noprint"><v-icon color="grey" @click="borrarestudiodetitulo">mdi-trash-can-outline</v-icon></v-col>
            </v-row>

            <div
              v-for="partida in partidas"
              :key="partida.id"
            >
              <v-row
              cols="12"
              class="ma-4 text-body-2 justify-space-between printstyle-row"
              >
                <v-col cols="6" class="pa-0 printstyle">{{ partida.descripcion }}</v-col><v-col cols="5" class="pa-0 pr-2 text-right printstyle printstyle-partidas-currency">{{ partida.honorariospartida | toCurrency }}</v-col><v-col cols="1" class="pa-0 text-right noprint"><v-icon color="grey" @click="borrarpartida(partida.id)">mdi-trash-can-outline</v-icon></v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-row
            cols="12"
            class="px-4 my-0"
            >
              <v-col
              cols="7"
              class="pr-0"
              >
                <h2 class="text-h6 pr-0 red--text">Total Honorarios</h2>
              </v-col>
              <v-col
              cols="5 pl-0 text-right"
              >
                <h2 class="text-h6 red--text">{{ this.variables.totalhonorarios | toCurrency }}</h2>
              </v-col>
            </v-row>
          </v-card>

          <v-row>
            <v-col
            cols="7"
            class="pa-0"
            >
              <h2 class="my-8 pl-4 text-h5 text-md-h4 red--text font-weight-bold printstyle">COSTO TOTAL:</h2>
            </v-col>
            <v-col
            cols="5"
            class="pa-0 text-right"
            >
              <h2 class="my-8 pr-4 text-h5 text-md-h4 red--text font-weight-bold printstyle">{{ variables.costototal | toCurrency }}</h2>
            </v-col>
          </v-row>

        </v-col>

          <div class="my-6 text-right noprint">
            <v-btn
              tile
              large
              class="ma-2"
              color="primary"
              @click="volver"

            >
            <v-icon
              left
              dark
              class="white--text"
            >
              mdi-arrow-left
            </v-icon>
            Volver
            </v-btn>
            <v-btn
              tile
              large
              class="ma-2"
              color="primary"
              @click="printWindow()"
            >
            <v-icon
              left
              dark
              class="white--text"
            >
              mdi-printer
            </v-icon>
            Imprimir
            </v-btn>
          </div>

      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
  @media print {
      .body {
      color: #000;
      background: #fff;
      }
      .theme--dark.v-divider {
          border-color: rgba(0, 0, 0, 0.12);
      }
      .noprint {
        display: none;
      }
      .printstyle {
        color: black !important;
        max-width: 450px;
        padding-top: 2px !important;
        padding-bottom: 2px !important;
        font-size: 0.75rem !important;
      }
      .printstyle-row {
        margin: 0px !important;
        padding-left: 16px;
        padding-right: 16px;
      }
      .printstyle-heading {
        font-size: 0.8333rem !important;
        padding-top: 4px;
        padding-bottom: 4px;
      }
      .printstyle h2 {
        font-size: 0.8333rem !important;
      }
      .printstyle-partidas-currency {
        padding-right: 0px !important;
      }
  }
</style>

<script>
export default {  
  props: ['variables'],
  data () {
    return {
      dialoghonorariosnotariales: false,
      dialogpartidas: false,
      nuevapartidadescripcion: '',
      nuevapartidahonorariospartida: 0,
      partidasRules: [
        value => !!value || 'Describa la partida',
      ],
      valorRules : [
        value => !!value || 'Debe entrar una cantidad en números',
      ],
      partidas: [],
    }
  },
  methods:{
    printWindow: function () {		
	    window.print();
    },
    cambiar () {
      if(this.$refs.form.validate()){
          this.dialoghonorariosnotariales = false;
      }
    },
    registrodelete () {
      this.variables.comprobantepresentacion = 0
      this.variables.presentaciontelematica = 0
      this.variables.comprobanteinscripcion = 0
      this.variables.rentasinternaspresentacion = 0
      this.variables.totalarancelesregistro = this.variables.comprobantepresentacion + this.variables.presentaciontelematica + this.variables.comprobanteinscripcion + this.variables.rentasinternaspresentacion
      this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios
      this.variables.aranceles = !this.variables.aranceles
    },
    volver () {
      this.variables.alerta = false
      this.variables.alerta2 = false
      this.$router.push('/');
    },
    borrarestudiodetitulo () {
      this.variables.estudiodetitulo = !this.variables.estudiodetitulo
      if (this.variables.estudiodetitulo) {
        this.variables.precioestudiodetitulo = 75
      }
      else {
        this.variables.precioestudiodetitulo = 0
      }
      this.variables.totalhonorarios = this.variables.honorariosnotariales + this.variables.precioestudiodetitulo + this.variables.totalpartidas
      this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios
    },
    borrarpartida (id) {
    this.partidas = this.partidas.filter(partida => partida.id !== id);
      this.variables.totalpartidas = this.partidas.reduce(function (total, currentvalue) {
        return total + currentvalue.honorariospartida;
      }, 0);
      this.variables.totalhonorarios = this.variables.honorariosnotariales + this.variables.precioestudiodetitulo + this.variables.totalpartidas
      this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios
    },
    cerrardialogohonorariosnotariales () {
      this.dialoghonorariosnotariales = false
      this.variables.totalhonorarios = this.variables.honorariosnotariales + this.variables.precioestudiodetitulo + this.variables.totalpartidas
      this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios
    },
    cerrardialogpartidas () {
      this.$refs.formpartidas.reset()
      this.nuevapartidahonorariospartida = 0
      this.dialogpartidas = false
    },
    anadirpartida () {
      if(this.$refs.formpartidas.validate()){
        let nuevaPartida = {
          id: Date.now(),
          descripcion: this.nuevapartidadescripcion,
          honorariospartida: this.nuevapartidahonorariospartida
        }
        this.partidas.push(nuevaPartida)

        this.$refs.formpartidas.reset()
        this.nuevapartidahonorariospartida = 0
        this.dialogpartidas = false
        this.variables.totalpartidas = this.partidas.reduce(function (total, currentvalue) {
          return total + currentvalue.honorariospartida;
        }, 0);
        this.variables.totalhonorarios = this.variables.honorariosnotariales + this.variables.precioestudiodetitulo + this.variables.totalpartidas
        this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios
      }
    }
	}
}
</script> 

<!--

-->